var _circle, _circle2, _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgToiletFlushSensor = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 63,
  height: 60,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 30,
  r: 30,
  fill: "#F5F5F5"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 52.5,
  cy: 49.5,
  r: 7.5,
  fill: "#FF8080",
  className: "toilet-flush-sensor_svg__sensor-connection-status"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "gray",
  className: "toilet-flush-sensor_svg__sensor-no-status"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 52.5,
  cy: 49.5,
  r: 7.5,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m49 46 7 7M56 46l-7 7"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  className: "toilet-flush-sensor_svg__no-battery-status",
  mask: "url(#toilet-flush-sensor_svg__mask0_18487_10634)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M52.167 28.667h1.666v-5h-1.666zM53 32q.354 0 .594-.24.24-.239.24-.593a.8.8 0 0 0-.24-.594.8.8 0 0 0-.594-.24.8.8 0 0 0-.594.24.8.8 0 0 0-.24.594q0 .354.24.594T53 32m-3.333 3.334a.8.8 0 0 1-.594-.24.8.8 0 0 1-.24-.594V21.167q0-.354.24-.594t.594-.24h1.666v-1.666h3.334v1.667h1.666q.354 0 .594.24.24.239.24.593V34.5q0 .354-.24.594a.8.8 0 0 1-.594.24zm.833-1.667h5V22h-5z"
}))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  fill: "#003252",
  clipPath: "url(#toilet-flush-sensor_svg__clip0_39293_154474)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.42 22.359a.87.87 0 0 1 .791.55h1.57a.16.16 0 0 1 .157.156v.286a.16.16 0 0 1-.157.155l-1.57.012a.835.835 0 0 1-.792.537.853.853 0 0 1-.851-.847c0-.466.384-.849.851-.85"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M27.034 19a2.9 2.9 0 0 1 2.866 2.475l.61 4.636h7.638c1.355 0 2.459 1.1 2.459 2.44a1.8 1.8 0 0 1-.3 1.003c.228.43.36.92.36 1.446a5.49 5.49 0 0 1-4.185 5.33l-1.966.478-.336 1.219a3.16 3.16 0 0 1-3.034 2.307H26.47a3.046 3.046 0 0 1-3.046-3.036v-2.115l-.623-.323a3.94 3.94 0 0 1-2.134-3.501v-9.012a3.354 3.354 0 0 1 3.356-3.346zm-3.191 1.587a1.767 1.767 0 0 0-1.593 1.76v8.999c0 .884.491 1.697 1.283 2.116l.826.43c.396.214.66.634.66 1.088v2.33c0 .801.66 1.458 1.463 1.458h4.677a1.55 1.55 0 0 0 1.499-1.147l.515-1.877a.42.42 0 0 1 .3-.298l2.65-.646a3.91 3.91 0 0 0 2.985-3.789c0-.824-.672-1.493-1.499-1.493h-7.817a.476.476 0 0 1-.468-.407l-.036-.263h9.436c.168 0 .3-.13.3-.298a.866.866 0 0 0-.864-.86h-8.285a.856.856 0 0 1-.852-.754l-.682-5.246a1.305 1.305 0 0 0-1.295-1.124h-3.01z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.339 17.458c.037-.26.384-.417.733-.29a4.07 4.07 0 0 1 2.416 2.425c.126.35-.03.699-.289.736-.26.037-.504-.149-.6-.409a3.1 3.1 0 0 0-1.853-1.86c-.26-.096-.445-.342-.407-.602M40.309 15.026a6.36 6.36 0 0 1 4.329 4.343c.096.32-.066.633-.325.685-.26.052-.511-.141-.593-.416a5.42 5.42 0 0 0-3.685-3.698c-.267-.075-.46-.328-.415-.595l.008.007c.044-.252.355-.415.68-.327"
}))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
  className: "toilet-flush-sensor_svg__sensor-full-battery",
  mask: "url(#toilet-flush-sensor_svg__mask0_38170_106501)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#14B814",
  d: "M49.833 35.667a.8.8 0 0 1-.593-.24.8.8 0 0 1-.24-.594V21.5q0-.354.24-.594t.593-.24H51.5V19h3.333v1.667H56.5q.354 0 .594.24.24.239.24.593v13.333q0 .354-.24.594a.8.8 0 0 1-.594.24z"
}))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg",
  className: "toilet-flush-sensor_svg__sensor-low-battery",
  mask: "url(#toilet-flush-sensor_svg__mask1_951_12431)",
  transform: "translate(43 17)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FF8080",
  d: "M9.167 11.667h1.666v-5H9.167zM10 15q.354 0 .594-.24t.24-.594a.8.8 0 0 0-.24-.593.8.8 0 0 0-.594-.24.8.8 0 0 0-.594.24.8.8 0 0 0-.24.593q0 .355.24.594.24.24.594.24m-3.333 3.333a.8.8 0 0 1-.594-.24.8.8 0 0 1-.24-.593V4.167q0-.356.24-.594.24-.24.594-.24h1.666V1.667h3.334v1.666h1.666q.354 0 .594.24t.24.594V17.5q0 .354-.24.594a.8.8 0 0 1-.594.24zm.833-1.666h5V5h-5z"
}))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
  className: "toilet-flush-sensor_svg__sensor-medium-battery",
  mask: "url(#toilet-flush-sensor_svg__mask0_951_9234)",
  transform: "translate(43 17)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F9C030",
  d: "M6.667 18.333a.8.8 0 0 1-.594-.24.8.8 0 0 1-.24-.593V4.167q0-.356.24-.594.24-.24.594-.24h1.666V1.667h3.334v1.666h1.666q.354 0 .594.24t.24.594V17.5q0 .354-.24.594a.8.8 0 0 1-.594.24zM7.5 15h5V5h-5z"
}))));
export default SvgToiletFlushSensor;